import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import IMobxProviderContext from '../interfaces/IMobxProviderContext';
import { IRootDataAccessStore } from '../RootDataAccessStore';

const useDataAccessStore = (): IRootDataAccessStore => useContext<IMobxProviderContext>(MobXProviderContext as any).rootDataAccessStore;

export default useDataAccessStore;
